import {approveOrder, cancelOrder, changeLine, deleteLine, addPayment, addDiscount, cloneForResend} from "@/services/approval";
import {getOrderInfo} from '@/services/checkout';
import { changeShippingMethod } from "../services/approval";

export default {
  state: {
    // Order loaded for viewing in orders screen
    // By default we act on this order
    order: null

    // TODO move recent orders logic here as well
  },
  mutations: {
    setOrderDetails(state, order) {
      state.order = order;
      // TODO update any recent orders as well
    }
  },
  actions: {
    loadOrderDetails({state, dispatch, commit}, id) {
      // Nothing to do if order is in state already
      if (state.order && state.order.id === id) return;

      // Clear state so old data isn't shown
      commit('setOrderDetails', null);

      // Load state
      return dispatch('reloadOrderDetails', id);
    },
    async reloadOrderDetails({state, commit, dispatch}, id) {
      // Get from server. If id not passed, reload current order
      let orderInfo = await getOrderInfo(id||state.order.id);
      commit('setOrderDetails', orderInfo);
      dispatch('updateRecentOrders');
    },
    async approveOrder({state, dispatch}, payment) {
      if (state.order.needs_payment) {
        let {saved_card} = payment;
        await addPayment(state.order.url, saved_card);
      }
      await approveOrder(state.order.id);
      return dispatch('reloadOrderDetails');
    },
    async cancelOrder({state, dispatch}, cancellation_reason) {
      await cancelOrder(state.order.id, cancellation_reason);
      return dispatch('reloadOrderDetails');
    },
    async changeOrderLine({state, dispatch}, {line, product, boxSize}) {
      await changeLine(state.order.id, line, product, boxSize);
      return dispatch('reloadOrderDetails');
    },
    async deleteOrderLine({state, dispatch}, {order, line}) {
      if (order) await dispatch('loadOrderDetails', order);
      await deleteLine(state.order.id, line);
      return dispatch('reloadOrderDetails');
    },
    async addOrderDiscount({state, dispatch}, voucherCode) {
      await addDiscount(state.order.id, voucherCode);
      return dispatch('reloadOrderDetails');
    },
    async cloneForResend({commit}, {order, lines}) {
      let newOrder = await cloneForResend({source: order, lines});
      return commit('setOrderDetails', newOrder);
    },
    async changeShippingMethod({dispatch, state}, {order, shipping_method}) {
      if (!order) order = state.order.id;
      await changeShippingMethod(order, shipping_method);
      return dispatch('reloadOrderDetails', order);
    },


    loadApprovers({dispatch}) {
      return dispatch('loadTeamMembers');
    },
  },
  getters: {
    // TODO use local state
    // This re-uses the "last order stuff"
    orderDetails: state => state.order,
    approvers: (state, getters) => getters.members.filter(m => m.user_type == 'admin').map(m => ({name: `${m.first_name} ${m.last_name}`, email: m.email}))
  }
}



// WEBPACK FOOTER //
// ./src/store/approval.js